import React from "react";

const PosIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5379 7.27912C10.5627 7.27912 9.75754 8.05685 9.75754 9.03203V24.9262C9.75754 25.9014 10.5627 26.6792 11.5379 26.6792H20.4624C21.4376 26.6792 22.2427 25.9014 22.2427 24.9262V9.03203C22.2427 8.05685 21.4376 7.27912 20.4624 7.27912H11.5379ZM8.47754 9.03203C8.47754 7.38764 9.84045 6.04041 11.5379 6.04041H20.4624C22.1598 6.04041 23.5227 7.38764 23.5227 9.03203V24.9262C23.5227 26.5706 22.1598 27.9179 20.4624 27.9179H11.5379C9.84045 27.9179 8.47754 26.5706 8.47754 24.9262V9.03203Z"
      />
      <path
        d="M19.1949 3.67874V9.29035H12.7998V3.67874L13.601 3.17167C13.7583 3.07185 13.9795 3.07185 14.1368 3.17167L14.6677 3.50705C14.825 3.60687 15.0462 3.60687 15.2035 3.50705L15.7344 3.17167C15.8917 3.07185 16.1129 3.07185 16.2702 3.17167L16.801 3.50705C16.9583 3.60687 17.1795 3.60687 17.3368 3.50705L17.8677 3.17167C18.025 3.07185 18.2462 3.07185 18.4035 3.17167L19.1998 3.67475L19.1949 3.67874Z"
        fill="#57CC99"
      />
      <path d="M17.9205 21.9768H14.0797C13.5713 21.9768 13.1592 22.3807 13.1592 22.879C13.1592 23.3773 13.5713 23.7812 14.0797 23.7812H17.9205C18.4288 23.7812 18.8409 23.3773 18.8409 22.879C18.8409 22.3807 18.4288 21.9768 17.9205 21.9768Z" />
      <rect
        x="11.7334"
        y="11.3549"
        width="8.53333"
        height="4.12903"
        rx="0.5"
        fill="#57CC99"
      />
    </svg>
  );
};

export default PosIcon;
